export let guest_groups = ["SantQ","Tortajada","Canoves","Familia Gemma","Familia Mati","BCN Mati","Feina Mati","Varis Gemma","Varis Mati"];